import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { makeObservable, observable, action } from 'mobx';
import FiltersStore from "Stores/DocumentHistory/FiltersStore";
import AppStore from 'Stores/AppStore';
import 'Styles/commonComponents/FiltersPanel/FiltersPanel.scss';
import CheckboxWithText from "Components/Common/CheckboxWithText";
import 'Styles/filterProtocolOrDocument.scss';
import FilterBlockDateTimeRange from "Components/Common/FiltersPanel/FilterBlockDateTimeRange";

class FiltersPanel extends Component {

    constructor() {
        super();
    }

    render() {
        var controlsNonInitiativeClassName = FiltersStore.filtersRender.includeInitiative ? " disabled" : "";

        return (
            <div className='filter-panel'>
                <div
                    id="regnum-alias-content"
                    className={controlsNonInitiativeClassName}
                >
                    <span>{AppStore.isMeeting ? 'Рег. №' : 'Рег. № РК/РКПД'}</span>
                    <input
                        id='filter-regnum-alias'
                        placeholder='Введите рег. номер'
                        className='regnum-input-placeholder-color'
                        onChange={action(e => FiltersStore.filtersRender.regNumAlias = e.target.value)}
                        value={FiltersStore.filtersRender.regNumAlias}
                    />
                </div>

                <CheckboxWithText
                    className={controlsNonInitiativeClassName}
                    checked={FiltersStore.filtersRender.matchWholeWord}
                    onChange={(checked) => FiltersStore.filtersRender.matchWholeWord = checked}
                    text="Строгое соответствие"
                />
                {AppStore.isMeeting ? null :
                    <CheckboxWithText
                        checked={FiltersStore.filtersRender.includeInitiative}
                        onChange={action((checked) => {
                            FiltersStore.filtersRender.includeInitiative = checked;
                            if (checked) {
                                FiltersStore.filtersRender.regNumAlias = '';
                                FiltersStore.filtersRender.matchWholeWord = false;
                                FiltersStore.filtersRender.regDateStart = null;
                                FiltersStore.filtersRender.regDateEnd = null;
                            }
                        })}
                        text="Инициативное поручение"
                    />
                }

                <FilterBlockDateTimeRange
                    title="Дата регистрации в СЭД"
                    disabled={FiltersStore.filtersRender.includeInitiative}
                    getValueFrom={() => FiltersStore.filtersRender.regDateStart}
                    setValueFrom={value => FiltersStore.filtersRender.regDateStart = value}
                    getValueTo={() => FiltersStore.filtersRender.regDateEnd}
                    setValueTo={value => FiltersStore.filtersRender.regDateEnd = value}
                    getRenderStore={() => FiltersStore.renderStore.dates}
                    setRenderStore={val => FiltersStore.renderStore.dates = val}
                    isTop={false}
                    getMinDate={() => AppStore.isMeeting
                        ? FiltersStore.filtersValues.meetingMinValueRegDate
                        : FiltersStore.filtersValues.docMinValueRegDate}
                    timeVisible={false}
                />
            </div>
        )
    }
}

export default observer(FiltersPanel);